/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = Engine
 *
 * 1 = Transmission
 *
 * 2 = Horn
 *
 * 3 = ExteriorLights
 *
 * 4 = WiperBladesAndArms
 *
 * 5 = Interior
 *
 * 6 = Interior2
 *
 * 7 = InteriorLampsAndDashLights
 *
 * 8 = WashersAndWipersFunction
 *
 * 9 = Belts
 *
 * 10 = EngineOil
 *
 * 11 = Coolant
 *
 * 12 = Screenwash
 *
 * 13 = BrakeFluid
 *
 * 14 = BrakeDiscsAndPadsFOrR
 *
 * 15 = Exhaust
 *
 * 16 = Steering
 *
 * 17 = Suspension
 *
 * 18 = Misc
 */
export enum VHCRecordCheckItemTypes {
  Engine = 0,
  Transmission = 1,
  Horn = 2,
  ExteriorLights = 3,
  WiperBladesAndArms = 4,
  Interior = 5,
  Interior2 = 6,
  InteriorLampsAndDashLights = 7,
  WashersAndWipersFunction = 8,
  Belts = 9,
  EngineOil = 10,
  Coolant = 11,
  Screenwash = 12,
  BrakeFluid = 13,
  BrakeDiscsAndPadsFOrR = 14,
  Exhaust = 15,
  Steering = 16,
  Suspension = 17,
  Misc = 18,
}
